import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService {

  constructor(
    private http: HttpClient
  ) {

  }

  resetPassword(email: string) {
    const endpoint = environment.apiUrl + "/api/reset-password";

    return this.http.post(endpoint, {
      email: email
    })
  }

  changePassword(token: string, password: string, password_confirmation: string) {

    const bearerToken = "Bearer " + token;
    const endpoint = environment.apiUrl + "/api/change-password"; // + token;

    return this.http.post(endpoint, {
      password: password,
      password_confirmation: password_confirmation
    },
      { headers: new HttpHeaders().set("Authorization", bearerToken) })
  }
}
